module.exports = __webpack_public_path__ + "img/uk_flag.68b4d830.svg";